import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import Layout from './components/PheonixLayout';
import Home from './pages/Home';

const App: React.FC = () => {
  const theme = createTheme();
 const sections = {
    aboutRef: React.createRef<HTMLDivElement>(),
    featureRef: React.createRef<HTMLDivElement>(),
    contactRef: React.createRef<HTMLDivElement>(),
    testimonialRef: React.createRef<HTMLDivElement>(),
    templateRef : React.createRef<HTMLDivElement>(),
    grantsRef: React.createRef<HTMLDivElement>(),
  };
return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Layout sections={sections}>
          <Routes>
            <Route path="/" element={<Home sections={sections} />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
};
export default App;